import script from "./WhatsAppBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppBubble.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppBubble.vue?vue&type=style&index=0&id=e7fc7c54&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7fc7c54"]])

export default __exports__